import { render, staticRenderFns } from "./CopilotToolCallResultMediaClip.vue?vue&type=template&id=a6bb12f4"
import script from "./CopilotToolCallResultMediaClip.vue?vue&type=script&lang=ts"
export * from "./CopilotToolCallResultMediaClip.vue?vue&type=script&lang=ts"
import style0 from "./CopilotToolCallResultMediaClip.vue?vue&type=style&index=0&id=a6bb12f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports